import React, { PureComponent } from 'react'
import cx from 'classnames'
import './index.css'

class Button extends PureComponent {
  render() {
    const { children, types, ...props } = this.props

    return (
      <button
        type="button"
        className={ cx('button', ...types) }
        { ...props }>
        { children }
      </button>
    )
  }
}

Button.defaultProps = {
  types: [],
}

export default Button



// WEBPACK FOOTER //
// ./src/components/Button/index.js